import { useTranslation } from 'react-i18next'

import ArrowGoBackIcon from '@wwt/shared/assets/icons/outline/arrow-go-back.svg'
import CrossIcon from '@wwt/shared/assets/icons/outline/close.svg'

import { Button } from '@/shared/ui/Button'

export interface RestartTutorialPopupProps {
	onClose: () => void
	onSubmit: () => void
}

export const RestartTutorialPopup = ({
	onClose,
	onSubmit
}: RestartTutorialPopupProps) => {
	const { t } = useTranslation('tutorial')

	const handleStartTutorial = () => {
		onSubmit()
		onClose()
	}

	return (
		<div data-wwt-id="tutorial__restart-tutorial--popup">
			<div className="mb-2 flex justify-between">
				<p className="ts-5 mb:ts-2">{t('restartPopup.title')}</p>

				<button onClick={onClose}>
					<CrossIcon className="h-6 w-6 text-gray-300" />
				</button>
			</div>

			<p className="ts-7 mb-6">{t('restartPopup.description')}</p>

			<div>
				<Button
					className="w-full"
					variant="secondary"
					size="sm"
					onClick={handleStartTutorial}
				>
					<ArrowGoBackIcon className="mr-2 h-6 w-6" />

					{t('restartPopup.button')}
				</Button>
			</div>
		</div>
	)
}
